import apiService from 'services/apiService';

const baseUrl = `${window._env_.MONITOR_API_DOMAIN}`;

const postExportClientList = (companyId, body) => {
  const url = `${baseUrl}/v1/entities/${companyId}/introducer/clients/export`;
  return apiService.post(url, body);
};

export { postExportClientList };
